import { Box, Grid } from "@mui/material";
import { useFormik } from "formik";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../../components/common/FormikControl";
import { useSelector } from "react-redux";
import { selectApprovedLSMHasNaCycle, selectApprovedLSMHighestCycle } from "../../../slices/logisticSlice";
import { useEffect, useState } from "react";

  const Filter = ({ onApply, onClear, initialFilters  }) => {

  const initialValues = {
    // clinical_status: "",
    // Financial_status: "",
    phase_type: "",
    product: "",
    cycle:[],
    ...initialFilters
  }

  // const clinicialStatusOptions = [
  //   { value: 1, label: 'Feasible' },
  //   { value: 2, label: 'Non Feasible' }
  // ]

  // const financialStatusOptions = [
  //   { value: 1, label: 'Feasible' },
  //   { value: 2, label: 'Non Feasible' }
  // ]
    const [cycleOptions, setCycleOptions] = useState([]);

    const highestCycle = useSelector(selectApprovedLSMHighestCycle);
    const hasNaCycle = useSelector(selectApprovedLSMHasNaCycle);

  const typeOptions = [
    { value: 'PMS', label: 'PMS' },
    { value: 'Commercial', label: 'Commercial' },
    { value: 'Trial', label: 'Trial' },
  ]

  // const productOptions = [
  //   { value: 'bcma', label: 'BCMA' },
  //   { value: 'carT', label: 'CAR-T' }
  // ]
const generateCycleOptions = (highestCycle, hasNaCycle) => {
  const options = [];
  if (hasNaCycle === 1) {
    options.push({
      value: "N/A",
      label: "N/A",
    });
  }
  const match = highestCycle?.match(/\d+/);
  if (match) {
    const max = parseInt(match[0], 10);
    for (let i = 1; i <= max; i++) {
      options.push({
        value: `Cycle ${i}`,
        label: `Cycle ${i}`,
      });
    }
  }
  return options;
};
useEffect(() => {
  const options = generateCycleOptions(
  highestCycle,
  hasNaCycle
  );
  setCycleOptions(options);
},  [hasNaCycle, highestCycle]);

  const handleCycleChange = (event) => {
    const selectedValues =
      typeof event.target.value === "string"
        ? event.target.value.split(",")
        : event.target.value;

    const filtered = Array.isArray(selectedValues)
      ? selectedValues.filter(Boolean)
      : [];
    formik.setFieldValue("cycle", filtered);
  };
  const formOptions = [
    // {
    //   label: 'Clinical Status',
    //   type: 'checkbox',
    //   name: 'clinical_status',
    //   options: clinicialStatusOptions
    // },
    // {
    //   label: 'Financial Status',
    //   type: 'checkbox',
    //   name: 'Financial_status',
    //   options: financialStatusOptions
    // },
    {
      label: 'Type',
      type: 'checkbox',
      name: 'phase_type',
      options: typeOptions
    },
     {
      label: 'Cycle',
      type: 'select',
      multiple: true,
      name: 'cycle',
      placeholder: 'Select Cycle',
      options: cycleOptions,
      onChange: handleCycleChange
    }
    // {
    //   label: 'Product',
    //   type: 'select',
    //   name: 'product',
    //   placeholder: 'Select Product',
    //   options: productOptions
    // }
  ]


  
  const handleSubmit = (values) => {
    onApply(values);
  }

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: handleSubmit
  })

  const handleClear = () => {
    formik.resetForm();
    onClear();
  };

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        {formOptions.map((props, key)=>(
          <Grid key={key} item xs={12}>
          <FormikControl formik={formik} {...props} />
          </Grid>
        ))}
        
        <Box sx={{ display: "flex",justifyContent: "space-between", gap: 2, marginTop: "10px" }}>
            <LoadingButton size="large" sx={{ borderRadius: "6px" }}  onClick={handleClear} variant="outlined">Clear Filter</LoadingButton>
            <LoadingButton size="large" sx={{ borderRadius: "6px" }}  type="submit" variant="contained">Apply Filter</LoadingButton>
          </Box>
      </form>
    </Box>
  );
}

export default Filter;